import React from 'react'
import RangeDatePickerAndActionsLayout from '../../../components/Layouts/range-date-picker-and-actions-layout'
import { ActionButtonEnum } from '../../../enums/actionButtonEnum'
import { getBingoPlayReport, getGamePerformanceReport } from '../../../services/reports'
import { DateFormatEnum } from '../../../enums/dateFormatEnum'
import {useAuth} from "../../../context/AuthProvider/useAuth";

function ReportBingoPlay() {
    const  affiliation  = useAuth().response?.affiliation

    return (
    <RangeDatePickerAndActionsLayout
      actions={[
        ActionButtonEnum.REFRESH, 
        ActionButtonEnum.SAVE_PDF, 
        ActionButtonEnum.SAVE_CSV
      ]}
      onRefresh={(startDateRage, endDateRange, output) =>
        getBingoPlayReport({
          beginDate: startDateRage.format(DateFormatEnum.YEAR_MONTH_DAY),
          endDate: endDateRange.format(DateFormatEnum.YEAR_MONTH_DAY),
          output,
        })
      }
      maxDays={affiliation==="manufacturer" || affiliation==="investigator"?365: 31}
    />
  )
}

export default ReportBingoPlay
